import React, { useEffect, useState } from 'react'
import CommonButton from '../Components/CommonButton';
import CommonInput from '../Components/CommonInput';
import { useLocation, useNavigate } from 'react-router-dom';
import { forgot_password } from '../services';
import ButtonLoader from '../Components/ButtonLoader';

function ForgetPassword() {
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({ email: '' });
    const [resMsg, setResMsg] = useState('');
    const [errResMsg, setErrResMsg] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const onChangeHandler = (e) => {
        const { name, value } = e.target;
        const setters = {
            email: setEmail
        };
        if (setters[name]) {
            setters[name](value);
        }
        setErrors('')
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (!validate()) {
            setIsLoading(false);
            return;
        }

        try {
            const passData = {
                emailId: email
            };

            const response = await forgot_password(passData);
            const status = response?.statusCode?.status;
            const responseData = response?.statusCode?.response_data;
            const successMessage = responseData?.message;
            const is_reset = responseData?.data?.is_reset;
            const get_email = responseData?.data?.email;
            const errorMessage = response?.errors?.message;
            const errResMsg = response?.error?.message
            if (status === 1 && successMessage) {
                setResMsg(successMessage);
                setErrResMsg('');

                sessionStorage.setItem('is_otp_allowed', 'forgot');
                sessionStorage.setItem('otp_source_page', location.pathname);
                // Carry the reset email + flag via router navigation state (ephemeral),
                // with a sessionStorage fallback so a refresh on the OTP screen still works.
                // No longer persisted to localStorage (avoids colliding with the logged-in
                // user's `email` key and leaving the reset email behind after the flow).
                sessionStorage.setItem('otp_email', get_email);
                sessionStorage.setItem('is_reset', String(is_reset));

                navigate('/otp-verification', { state: { email: get_email, isReset: is_reset } });
                setIsLoading(false);
            } else if (errResMsg) {
                setErrResMsg(errResMsg);
                setResMsg('');
                setIsLoading(false);
            } else if (errorMessage) {
                setErrResMsg(errorMessage)
                setIsLoading(false);
            }
        } catch (error) {
            console.error('API Error:', error);
            setErrResMsg('Network error. Please try again later.');
            setResMsg('');
            setIsLoading(false);
        }
    };

    const validate = () => {
        let emailError = '';
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) {
            emailError = 'Email is required';
            setIsLoading(false);
        } else if (!emailRegex.test(email)) {
            emailError = 'Enter a valid email';
            setIsLoading(false);
        }
        setErrors({ email: emailError });
        return !emailError;
    };

    return (
        <div className='sign-in-wrapper'>
            <div className='signin-left-panel'>
                <div className='signin-left-content'>
                    <p className='animated-tagline-novaai'>NOVA AI</p>
                    <p className='animated-tagline'>Unified Cyber Risk Intelligence Platform</p>
                </div>
            </div>

            <div className='signin-form-panel'>
                <div className='sign-in-wrper'>
                    <div className='logo_wrper'>
                        <img src='/assets/small_logo.svg' alt='Logo' width={300} height={90} />
                    </div>
                    <div className='card'>
                        <h1 className='title'>Forgot Password</h1>
                        <p className='auth_txt_color font_400 font_16'>
                            Enter the email address you used when you created the account,
                            and we will send you a code to reset your password
                        </p>
                        <form onSubmit={submitHandler} noValidate>
                            <div className='form-group'>
                                <label htmlFor='email' className='font_500 font_16 light_black'>Work Email</label>
                                <CommonInput
                                    id='email'
                                    type='email'
                                    name='email'
                                    value={email}
                                    onChange={(e) => onChangeHandler(e)}
                                    placeholder='abc@email.com'
                                    maxLength={50}
                                />
                                {errors.email && <p className='error-message'>{errors.email}</p>}
                            </div>
                            {resMsg && <p className='success-message'>{resMsg}</p>}
                            {errResMsg && <p className='error-message'>{errResMsg}</p>}
                            <CommonButton
                                type='submit'
                                className=''
                                text={isLoading ? <ButtonLoader /> : 'Submit'}
                            />
                        </form>

                        <p className='footer-text'>
                            <button onClick={() => navigate('/')}>Back to Login</button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ForgetPassword;
